module.exports = __webpack_public_path__ + "img/BlinkArt_Sword13_Blue.8d37de54.png";